import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { isSignedInAtom } from "./authAtoms";
import { useAtom } from "jotai";
import { SellingMode } from "@/api/AppApi/services/company/interfaces/ICompany";
import { checkSellingAvailability } from "@/utils/functions/functions";

const useSellingMode = () => {
  const [isSignedIn] = useAtom(isSignedInAtom);
  const { data, isFetching } = useGetCompanyQuery() ?? {};

  const {
    selling_mode,
    enable_sells,
    enable_checkout_for_guests,
    open_at,
    close_at,
  } = data?.result.theme.settings ?? {};
  const countryCode = data?.result?.contacts?.address?.country_code ?? "KW";
  const enableSells = checkSellingAvailability(
    selling_mode,
    enable_sells,
    open_at,
    close_at,
    countryCode,
  );

  const disableAddToCartForGuests = selling_mode === SellingMode.signedUpOnly;

  const enableCheckoutForGuests = selling_mode
    ? selling_mode === SellingMode.publicForAll
    : enable_checkout_for_guests;

  const enableAddToCart = !data
    ? true
    : isSignedIn || !disableAddToCartForGuests;

  const enableCheckout = !data ? true : isSignedIn || enableCheckoutForGuests;

  return { enableAddToCart, isFetching, enableSells, enableCheckout };
};

export default useSellingMode;
